import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { saveHotelIntegrationAPI } from "api/hotelIntegration";
import { testHotelIntegrationAPI } from "api/hotelIntegration";
import { deleteHotelAPI } from "api/hotels";

// Soft delete hotel
export const deleteHotel = createAsyncThunk(
  "hotels/deleteHotel",
  async (hotelId, { rejectWithValue }) => {
    try {
      const res = await deleteHotelAPI(hotelId);
      return { hotelId, data: res.data };
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || "Failed to delete hotel");
    }
  }
);

export const testIntegration = createAsyncThunk(
  "hotels/testIntegration",
  async ({ hotelId, data }, { rejectWithValue }) => {
    try {
      const res = await testHotelIntegrationAPI({ hotelId, data });
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || "Integration test failed");
    }
  }
);

export const connectIntegration = createAsyncThunk(
  "hotels/connectIntegration",
  async ({ hotelId, data }, { rejectWithValue }) => {
    try {
      const res = await saveHotelIntegrationAPI({ hotelId, data });
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || "Failed to save integration");
    }
  }
);

const initialState = {
  list: [],
  listLoading: false,
  listError: null,

  deleteLoading: false,
  deleteSuccess: false,
  deleteError: null,

  testIntegrationLoading: false,
  testIntegrationSuccess: false,
  testIntegrationError: null,
  testIntegrationResult: null,

  connectIntegrationLoading: false,
  connectIntegrationSuccess: false,
  connectIntegrationError: null,
};

const hotelsSlice = createSlice({
  name: "hotels",
  initialState,
  reducers: {
    resetDeleteHotelState: (state) => {
      state.deleteLoading = false;
      state.deleteSuccess = false;
      state.deleteError = null;
    },
    resetDeleteHotelState: (state) => {
      state.deleteLoading = false;
      state.deleteSuccess = false;
      state.deleteError = null;
    },

    resetTestIntegrationState: (state) => {
      state.testIntegrationLoading = false;
      state.testIntegrationSuccess = false;
      state.testIntegrationError = null;
      state.testIntegrationResult = null;
    },

    resetConnectIntegrationState: (state) => {
      state.connectIntegrationLoading = false;
      state.connectIntegrationSuccess = false;
      state.connectIntegrationError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      /* ================= DELETE HOTEL ================= */
      .addCase(deleteHotel.pending, (state) => {
        state.deleteLoading = true;
        state.deleteError = null;
        state.deleteSuccess = false;
      })
      .addCase(deleteHotel.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.deleteSuccess = true;

        state.list = state.list.filter((hotel) => hotel._id !== action.payload.hotelId);
      })
      .addCase(deleteHotel.rejected, (state, action) => {
        state.deleteLoading = false;
        state.deleteError = action.payload;
      })

      /* ================= TEST INTEGRATION ================= */
      .addCase(testIntegration.pending, (state) => {
        state.testIntegrationLoading = true;
        state.testIntegrationSuccess = false;
        state.testIntegrationError = null;
        state.testIntegrationResult = null;
      })
      .addCase(testIntegration.fulfilled, (state, action) => {
        state.testIntegrationLoading = false;
        state.testIntegrationSuccess = true;
        state.testIntegrationResult = action.payload;
      })
      .addCase(testIntegration.rejected, (state, action) => {
        state.testIntegrationLoading = false;
        state.testIntegrationError = action.payload;
      })

      /* ================= CONNECT INTEGRATION ================= */
      .addCase(connectIntegration.pending, (state) => {
        state.connectIntegrationLoading = true;
        state.connectIntegrationSuccess = false;
        state.connectIntegrationError = null;
      })
      .addCase(connectIntegration.fulfilled, (state, action) => {
        state.connectIntegrationLoading = false;
        state.connectIntegrationSuccess = true;
      })
      .addCase(connectIntegration.rejected, (state, action) => {
        state.connectIntegrationLoading = false;
        state.connectIntegrationError = action.payload;
      });
  },
});

export const { resetDeleteHotelState } = hotelsSlice.actions;

export default hotelsSlice.reducer;
